/**
 * @generated SignedSource<<7d4382fa97908f2de093af22fe8c1335>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogPostLanding_BlogPost$data = {
  readonly id: string;
  readonly title: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BlogPostContent_BlogPost" | "ProfileHireBox_BlogPostFragment">;
  readonly " $fragmentType": "BlogPostLanding_BlogPost";
};
export type BlogPostLanding_BlogPost$key = {
  readonly " $data"?: BlogPostLanding_BlogPost$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogPostLanding_BlogPost">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogPostLanding_BlogPost",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BlogPostContent_BlogPost"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileHireBox_BlogPostFragment"
    }
  ],
  "type": "BlogPost",
  "abstractKey": null
};

(node as any).hash = "9d5adc03fdf28c18c7649402856f2423";

export default node;
